module.exports = __webpack_public_path__ + "effective_question_bank.svg?c1f6354af5a5d373384f71da0c0c6ca3";


//////////////////
// WEBPACK FOOTER
// ./static/effective_question_bank.svg
// module id = 42
// module chunks = 0